import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

const COLS = [
  { key: "New", title: "New" },
  { key: "Picking", title: "Picking" },
  { key: "Packed", title: "Packed" },
  { key: "Ready", title: "Ready" },
];

export default function Picking() {
  const [orders, setOrders] = useState([]);
  const load = () => api.get("/grocery/queue").then(({data}) => setOrders(data)).catch(() => {});
  useEffect(() => { load(); const t = setInterval(load, 8000); return () => clearInterval(t); }, []);
  const move = async (oid, status) => {
    await api.patch(`/orders/${oid}/grocery`, { status });
    toast.success(status);
    load();
  };
  return (
    <div data-testid="picking-page">
      <h1 className="font-heading text-3xl text-[#FAF9F6] mb-6">Grocery Picking Queue</h1>
      <div className="grid md:grid-cols-4 gap-4">
        {COLS.map((col) => {
          const list = orders.filter((o) => (o.grocery_status || "New") === col.key);
          return (
            <div key={col.key} className="admin-card p-4">
              <h3 className="font-accent text-xs uppercase tracking-wider text-[#D4AF37] mb-3">{col.title} ({list.length})</h3>
              <div className="space-y-3">
                {list.map((o) => (
                  <div key={o.id} className="bg-[#0B0E14] border border-[#D4AF37]/15 rounded p-3" data-testid={`pick-${o.id}`}>
                    <div className="text-xs font-accent text-[#D4AF37]">{o.order_number}</div>
                    <div className="text-sm font-heading text-[#FAF9F6]">{o.customer_name}</div>
                    <ul className="text-xs text-[#FAF9F6]/70 my-2 space-y-0.5">
                      {o.items.filter(i => i.item_type === "grocery").map((i, idx) => (
                        <li key={idx}>{i.quantity}× {i.name}</li>
                      ))}
                    </ul>
                    <div className="flex gap-1">
                      {col.key === "New" && <button data-testid={`pick-start-${o.id}`} onClick={() => move(o.id, "Picking")} className="flex-1 text-xs bg-[#D4AF37] text-[#050505] py-1.5 rounded">Start</button>}
                      {col.key === "Picking" && <button data-testid={`pick-pack-${o.id}`} onClick={() => move(o.id, "Packed")} className="flex-1 text-xs bg-[#D4AF37] text-[#050505] py-1.5 rounded">Packed</button>}
                      {col.key === "Packed" && <button data-testid={`pick-ready-${o.id}`} onClick={() => move(o.id, "Ready")} className="flex-1 text-xs bg-[#2C4A3B] text-white py-1.5 rounded">Ready</button>}
                    </div>
                  </div>
                ))}
                {list.length === 0 && <div className="text-xs text-[#FAF9F6]/30 text-center py-6">Empty</div>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
